import React from 'react';
import PropTypes from 'prop-types';

import EventCard from '../../../../../components/cards/EventCard';
import EventCardSponsored from '../../../../../components/cards/EventCard/sponsored';
import AdWrapper from '../../../../../components/Ads/AdWrapper';
import { AdTypes } from '../../../../../utils/types';

import styles from '../../searchV2.scss';

const EventsList = ({
  events,
  auth,
  eventSearchConfig,
  shouldShowTwoRectangleAds,
  showAds,
}) => {
  const rectangleAdIndex = 3;
  const leaderboardAdIndex = 6;
  const isPowerUser = auth?.user?.isPowered;

  const renderSearchResultAds = (shouldInsertRectangleAd, shouldInsertWideLeaderboardAd) => {
    const { RECTANGLE_ONE, RECTANGLE_TWO, RECTANGLE_THREE, WIDE_LEADERBOARD_ONE } = AdTypes;
    return (
        <>
            {shouldInsertRectangleAd && (
            shouldShowTwoRectangleAds ? (
                <div className={styles.rectangleAdContainer}>
                    <AdWrapper type={RECTANGLE_ONE} data-testid="search-v2.events.ad.rectangle-1" />
                    <div className={styles.lastRectangleAd}>
                        <AdWrapper type={RECTANGLE_TWO} data-testid="search-v2.events.ad.rectangle-2" />
                    </div>
                </div>
            ) : (
                <div className={styles.rectangleAdContainer}>
                    <AdWrapper type={RECTANGLE_ONE} data-testid="search-v2.events.ad.rectangle-1" />
                    <AdWrapper type={RECTANGLE_TWO} data-testid="search-v2.events.ad.rectangle-2" />
                    <AdWrapper type={RECTANGLE_THREE} data-testid="search-v2.events.ad.rectangle-3" />
                </div>
            )
          )}
            {shouldInsertWideLeaderboardAd && (
            <div className={styles.leaderboardAdContainer}>
                <AdWrapper type={WIDE_LEADERBOARD_ONE} data-testid="search-v2.events.ad.wide-leaderboard" />
            </div>
          )}
        </>
    );
  };

  if (!events || events.length === 0) {
    return null;
  }

  return (
      <div>
          {isPowerUser ? (
          events.map((event, index) => {
            if (event.isSponsored) {
              return (
                  <EventCardSponsored
                      key={`e-ad-${event.source?.id || index}`}
                      featuredEvent={event}
                  />
              );
            }
            return (
                <EventCard
                    key={`e-${event.source?.id || index}`}
                    event={event.source}
                    auth={auth}
                    isSearchResultsPage={true}
                />
            );
          })
        ) : (
          events.map((event, index) => {
            const shouldInsertRectangleAd = showAds && eventSearchConfig?.showRectangle && index === rectangleAdIndex;
            const shouldInsertWideLeaderboardAd = showAds && eventSearchConfig?.showWideLeaderboard && index === leaderboardAdIndex;
            return (
                <React.Fragment key={`e-fragment-${event.source?.id || index}`}>
                    {renderSearchResultAds(shouldInsertRectangleAd, shouldInsertWideLeaderboardAd)}
                    <EventCard
                        key={`e-${event.source?.id || index}`}
                        event={event.source}
                        auth={auth}
                        isSearchResultsPage={true}
                    />
                </React.Fragment>
            );
          })
        )}
      </div>
  );
};

EventsList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({
    source: PropTypes.instanceOf(Object),
    isSponsored: PropTypes.bool,
  })).isRequired,
  auth: PropTypes.instanceOf(Object),
  eventSearchConfig: PropTypes.instanceOf(Object),
  shouldShowTwoRectangleAds: PropTypes.bool,
  showAds: PropTypes.bool,
};

EventsList.defaultProps = {
  auth: null,
  eventSearchConfig: {},
  shouldShowTwoRectangleAds: false,
  showAds: false,
};

export default EventsList;
